/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseResponseEntity } from '../models/BaseResponseEntity';
import type { CreateMultipleUserDto } from '../models/CreateMultipleUserDto';
import type { CreateMultipleUserEntity } from '../models/CreateMultipleUserEntity';
import type { CreateUserDto } from '../models/CreateUserDto';
import type { CreateUserEntity } from '../models/CreateUserEntity';
import type { GetFinancialLimitOptionsEntity } from '../models/GetFinancialLimitOptionsEntity';
import type { GetListUserEntity } from '../models/GetListUserEntity';
import type { GetOilMerchantUserEntity } from '../models/GetOilMerchantUserEntity';
import type { GetOneUserEntity } from '../models/GetOneUserEntity';
import type { GetScreenActionPermissionsEntity } from '../models/GetScreenActionPermissionsEntity';
import type { ResendAccountActivationEmailDto } from '../models/ResendAccountActivationEmailDto';
import type { UpdateOwnFinancialLimitDto } from '../models/UpdateOwnFinancialLimitDto';
import type { UpdateOwnFinancialLimitEntity } from '../models/UpdateOwnFinancialLimitEntity';
import type { UpdatePasswordDto } from '../models/UpdatePasswordDto';
import type { UpdatePointToUserDto } from '../models/UpdatePointToUserDto';
import type { UpdatePointToUserEntity } from '../models/UpdatePointToUserEntity';
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { UpdateUserFinancialLimitDto } from '../models/UpdateUserFinancialLimitDto';
import type { UpdateUserInfoEntity } from '../models/UpdateUserInfoEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserWalletManageService {
  /**
   * Gửi lại email khởi tạo tài khoản theo số điện thoại
   * @param requestBody
   * @returns BaseResponseEntity Đã đưa email vào hàng đợi gửi đến địa chỉ đã lưu của tài khoản
   * @throws ApiError
   */
  public static userManageControllerResendAccountActivationEmail(
    requestBody: ResendAccountActivationEmailDto,
  ): CancelablePromise<BaseResponseEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/user-wallet/manager/resend-account-activation-email',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns CreateUserEntity
   * @throws ApiError
   */
  public static userManageControllerCreateUser(
    requestBody: CreateUserDto,
  ): CancelablePromise<CreateUserEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/user-wallet/manager/create-user',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
        409: `Trùng số điện thoại, số tài khoản, email, CCCD hoặc thông tin tài khoản ảo`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns CreateMultipleUserEntity Batch user creation result
   * @throws ApiError
   */
  public static userManageControllerCreateMultiUser(
    requestBody: CreateMultipleUserDto,
  ): CancelablePromise<CreateMultipleUserEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/user-wallet/manager/create-multi-user',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns UpdateUserInfoEntity
   * @throws ApiError
   */
  public static userManageControllerUpdateUserInfo(
    requestBody: UpdateUserDto,
  ): CancelablePromise<UpdateUserInfoEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/user-wallet/manager/update-user',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
        404: `User not found`,
      },
    });
  }

  /**
   * @param userId search string
   * @returns BaseResponseEntity
   * @throws ApiError
   */
  public static userManageControllerActiveUser(
    userId: string,
  ): CancelablePromise<BaseResponseEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/user-wallet/manager/active-user/{userId}',
      path: {
        userId: userId,
      },
      errors: {
        400: `user is undefined, User already activated, User has been deleted`,
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param userId search string
   * @returns BaseResponseEntity
   * @throws ApiError
   */
  public static userManageControllerInactiveUser(
    userId: string,
  ): CancelablePromise<BaseResponseEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/user-wallet/manager/inactive-user/{userId}',
      path: {
        userId: userId,
      },
      errors: {
        400: `user is undefined, User already deactivated, User has been deleted`,
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param userId search string
   * @returns BaseResponseEntity
   * @throws ApiError
   */
  public static userManageControllerRemoveUser(
    userId: string,
  ): CancelablePromise<BaseResponseEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/user-wallet/manager/remove-user/{userId}',
      path: {
        userId: userId,
      },
      errors: {
        400: `User has been deleted`,
        401: `Unauthorized`,
        403: `Forrbidden`,
        404: `User not found`,
      },
    });
  }

  /**
   * List users
   * @param searchString Search by user's name or phone number
   * @param page Page
   * @param pageSize Page size
   * @param isActive Trạng thái hoạt động
   * @param role Role
   * @param objectType ObjectType
   * @param searchDetailContent Search keyword in detail contents
   * @param compId Company Id
   * @param isDeleted Is deleted
   * @returns GetListUserEntity
   * @throws ApiError
   */
  public static userManageControllerGetListUser(
    searchString?: string,
    page: string = '1',
    pageSize: string = '10',
    isActive?: boolean,
    role?: 'Agency' | 'Admin' | 'Mc' | 'OilMc' | 'ZOMc',
    objectType?: 'Driver' | 'Staff' | 'Partner' | 'Customer',
    searchDetailContent?: string,
    compId?: string,
    isDeleted?: boolean,
  ): CancelablePromise<GetListUserEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/manager/get-list',
      query: {
        searchString: searchString,
        page: page,
        pageSize: pageSize,
        isActive: isActive,
        role: role,
        objectType: objectType,
        searchDetailContent: searchDetailContent,
        compId: compId,
        isDeleted: isDeleted,
      },
      errors: {
        401: `Unauthorized`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns UpdatePointToUserEntity
   * @throws ApiError
   */
  public static userManageControllerAddPointToUser(
    requestBody: UpdatePointToUserDto,
  ): CancelablePromise<UpdatePointToUserEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/user-wallet/manager/add-point',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Value can't less than or equal 0, Insufficient balance`,
        401: `Unauthorized`,
        403: `Forrbidden`,
        404: `User not found, Can't get recipient information`,
        500: `INTERNAL_SERVER_ERROR`,
      },
    });
  }

  /**
   * @param amount Amount for transfer
   * @param toUserId to userId
   * @param reason Descripton transfer
   * @returns UpdatePointToUserEntity
   * @throws ApiError
   */
  public static userManageControllerSubtractPointToUser(
    amount: number,
    toUserId: string,
    reason: string,
  ): CancelablePromise<UpdatePointToUserEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/user-wallet/manager/subtract-point',
      path: {
        amount: amount,
        toUserId: toUserId,
        reason: reason,
      },
      errors: {
        400: `Value can't less than or equal 0, Insufficient balance`,
        401: `Unauthorized`,
        403: `Forrbidden`,
        404: `User not found, Can't get recipient information`,
        500: `INTERNAL_SERVER_ERROR`,
      },
    });
  }

  /**
   * @param userId userId
   * @returns GetOneUserEntity
   * @throws ApiError
   */
  public static userManageControllerGetOneUser(
    userId: string,
  ): CancelablePromise<GetOneUserEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/manager/get-user/{userId}',
      path: {
        userId: userId,
      },
      errors: {
        400: `User is deleted, System error`,
        401: `Unauthorized`,
        403: `Forrbidden`,
        404: `User not found`,
      },
    });
  }

  /**
   * @param userId
   * @param requestBody
   * @returns BaseResponseEntity Password updated successfully
   * @throws ApiError
   */
  public static userManageControllerUpdatePassword(
    userId: string,
    requestBody: UpdatePasswordDto,
  ): CancelablePromise<BaseResponseEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/user-wallet/manager/update-password/{userId}',
      path: {
        userId: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid password`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `User not found`,
      },
    });
  }

  /**
   * @returns GetFinancialLimitOptionsEntity
   * @throws ApiError
   */
  public static userManageControllerGetFinancialLimitOptions(): CancelablePromise<GetFinancialLimitOptionsEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/manager/financial-limit-options',
    });
  }

  /**
   * @param requestBody
   * @returns UpdateOwnFinancialLimitEntity
   * @throws ApiError
   */
  public static userManageControllerUpdateOwnFinancialLimitsByOptionsPath(
    requestBody: UpdateOwnFinancialLimitDto,
  ): CancelablePromise<UpdateOwnFinancialLimitEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/user-wallet/manager/financial-limit-options',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns UpdateOwnFinancialLimitEntity
   * @throws ApiError
   */
  public static userManageControllerUpdateOwnFinancialLimits(
    requestBody: UpdateOwnFinancialLimitDto,
  ): CancelablePromise<UpdateOwnFinancialLimitEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/user-wallet/manager/my-financial-limits',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Cập nhật hạn mức tài chính cho người dùng trong phạm vi được phép
   * @param userId
   * @param requestBody
   * @returns UpdateOwnFinancialLimitEntity
   * @throws ApiError
   */
  public static userManageControllerApiUpdateUserFinancialLimits(
    userId: string,
    requestBody: UpdateUserFinancialLimitDto,
  ): CancelablePromise<UpdateOwnFinancialLimitEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/user-wallet/manager/financial-limits/{userId}',
      path: {
        userId: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns GetScreenActionPermissionsEntity List of screen action and permission mappings
   * @throws ApiError
   */
  public static userManageControllerGetScreenActionPermissions(): CancelablePromise<GetScreenActionPermissionsEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/manager/screen-actions',
    });
  }

  /**
   * @returns GetOilMerchantUserEntity
   * @throws ApiError
   */
  public static userManageControllerGetAllMerchantOilUsers(): CancelablePromise<GetOilMerchantUserEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/manager/merchant-oil',
    });
  }
}
